export const ROLE_ADMIN = 'admin';
export const ROLE_GLASS_DESIGNER = 'designer';
export const ROLE_SALES = 'sale';
export const ROLE_TERRITORY = 'territory';

export const ROLES = [ROLE_ADMIN, ROLE_GLASS_DESIGNER, ROLE_SALES, ROLE_TERRITORY];